module.exports = __webpack_public_path__ + "static/media/bank-stars.5f4676e4.png";